import React, { useRef } from "react";
import Logo from '../../assets/Images/Docusafe_logo.webp';

export default function OTPVerifyCard({
  otpValues,
  onOtpChange,
  onOtpPaste,
  onOtpKeyDown,
  onVerify,
  loading
}) {
  const inputRefs = useRef([]);

  const handleChange = (e, idx) => {
    onOtpChange(e, idx);
    if (e.target.value && idx < otpValues.length - 1) {
      inputRefs.current[idx + 1].focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !otpValues[idx] && idx > 0) {
      inputRefs.current[idx - 1].focus();
    }
    if (onOtpKeyDown) onOtpKeyDown(e, idx);
  };

  return (
    <div className="section-bg-color d-flex align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 126px)' }}>
      <div className="otp-card bg-white rounded-1 shadow-lg p-2 p-md-5 mx-2 mx-md-0">
        <div className="text-center mb-4">
          <img src={Logo} alt="docusafe_logo" className="docusafe_logo" />
        </div>
        <div className="text-center mb-3">
          <h5 className="fw-bold mb-2">Please enter 6 digit Access Code</h5>
          <div className="text-muted small">received in the email</div>
        </div>
        <div className="d-flex justify-content-center gap-2 mb-4">
          {otpValues.map((val, idx) => (
            <input
              key={idx}
              type="text"
              inputMode="numeric"
              maxLength={1}
              className="otp-input"
              value={val}
              onChange={e => handleChange(e, idx)}
              onPaste={onOtpPaste}
              onKeyDown={e => {
                if (e.key === 'Enter' && otpValues.every(v => v)) {
                  onVerify(e);
                }
              }}
              ref={el => inputRefs.current[idx] = el}
              autoFocus={idx === 0}
              disabled={loading}
            />
          ))}
        </div>
        <button
          className="otp-btn w-100"
          onClick={onVerify}
          disabled={loading || otpValues.some(v => !v)}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>
      </div>
    </div>
  );
} 